import { ActionType, TableDataType, TableHeaderProps } from "../../interfaces/interface";

export const CONTACT_DETAILS_HEADINGS: TableHeaderProps[] = [
  {
    name: "id",
    title: "Id",
    type: TableDataType.TEXT,
    onClick: (rowData: any) => {},
    customClass: "",
    customStyle: {},
  },
    {
      name: "name",
      title: "Name",
      type: TableDataType.TEXT,
      onClick: (rowData: any) => {},
      customClass: "",
      customStyle: {},
    },
    {
      name: "phone",
      title: "Phone Number",
      type: TableDataType.TEXT,
      onClick: (rowData: any) => {},
      customClass: "",
      customStyle: {},
    },
    {
      name: "email",
      title: "Email",
      type: TableDataType.TEXT,
      onClick: (rowData: any) => {},
      customClass: "",
      customStyle: {},
    },
    {
      name: "message",
      title: "Message",
      type: TableDataType.TEXT,
      onClick: (rowData: any) => {},
      customClass: "",
      customStyle: {},
    },
    {
      name: "createdAt",
      title: "Date",
      type: TableDataType.DATE,
      onClick: (rowData: any) => {},
      customClass: "",
      customStyle: {},
    },
    
    {
      name: "action",
      title: "Action",
      type: TableDataType.ACTIONS,
      actionType: [
        {
          icon: "",
          name: ActionType.DELETE,
          onClick: (rowData: any) => {},
          customClass: "",
          customStyle: {},
        },
      ],
      customClass: "",
      customStyle: {},
    },
  ];